export const AUTH_COOKIE_NAME = 'coachingServices_auth_cookie';
export const AP_UNSUB_CALLED = 'coachingServices_AP_unsub_called_cookie';
export const URL_S3 = 'https://d2bfhuxozzsc0y.cloudfront.net/coachingServices';
